// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate, Link } from "react-router-dom";
// import {
//   FaHeart,
//   FaTint,
//   FaUtensils,
//   FaBrain,
//   FaFlask,
//   FaCalendarAlt,
//   FaChartLine,
//   FaDownload,
//   FaStar,
// } from "react-icons/fa";
// import Header from "../Components/Header";
// import Footer from "../Components/Footer";
// import { downloadHraReportPdf } from "../utils/hraPdf";
// import { toast } from "../Components/Toast";

// const CATEGORY_ICONS = {
//   cardiac: FaHeart,
//   cardiovascular: FaHeart,
//   metabolic: FaTint,
//   lifestyle: FaUtensils,
//   mental: FaBrain,
//   default: FaHeart,
// };

// const CATEGORY_DESCRIPTIONS = {
//   cardiac: "Your heart health indicators are within a healthy range.",
//   cardiovascular: "Your heart health indicators are within a healthy range.",
//   metabolic: "Some metabolic markers may benefit from closer monitoring.",
//   lifestyle: "Your activity levels are good, but strength training could help.",
//   mental: "Stress and sleep patterns show room for improvement.",
//   default: "Based on your responses in this category.",
// };

// const getCategoryIcon = (name) => {
//   const key = (name || "").toLowerCase();
//   const match = Object.keys(CATEGORY_ICONS).find((k) => key.includes(k));
//   return CATEGORY_ICONS[match] || CATEGORY_ICONS.default;
// };

// const getCategoryDescription = (name, prescribed) => {
//   if (prescribed) return prescribed;
//   const key = Object.keys(CATEGORY_DESCRIPTIONS).find((k) => (name || "").toLowerCase().includes(k));
//   return CATEGORY_DESCRIPTIONS[key] || CATEGORY_DESCRIPTIONS.default;
// };

// const scoreToStatus = (pct) => {
//   const p = Number(pct) || 0;
//   if (p >= 80) return { label: "OPTIMAL", color: "bg-primary text-white" };
//   if (p >= 60) return { label: "GOOD", color: "bg-primary-fixed/50 text-primary" };
//   if (p >= 40) return { label: "FAIR", color: "bg-tertiary-container text-on-tertiary-container" };
//   return { label: "ELEVATED", color: "bg-error-container text-error" };
// };

// const riskBadgeClass = (level) => {
//   const l = (level || "").toLowerCase();
//   if (l.includes("low")) return "bg-primary-fixed/30 text-primary";
//   if (l.includes("moderate") || l.includes("mod")) return "bg-error-container text-error border border-error/20";
//   if (l.includes("high")) return "bg-error-container text-error";
//   return "bg-surface-low text-on-surface-variant";
// };

// const WellnessRing = ({ score }) => {
//   const safe = Number.isFinite(score) ? Math.min(100, Math.max(0, score)) : 0;
//   const radius = 70;
//   const circumference = 2 * Math.PI * radius;
//   const offset = circumference - (safe / 100) * circumference;

//   return (
//     <div className="relative w-40 h-40 sm:w-48 sm:h-48 mx-auto">
//       <svg className="w-full h-full -rotate-90" viewBox="0 0 160 160">
//         <circle cx="80" cy="80" r={radius} fill="none" stroke="#e5e7eb" strokeWidth="12" />
//         <circle
//           cx="80"
//           cy="80"
//           r={radius}
//           fill="none"
//           stroke="#006A4E"
//           strokeWidth="12"
//           strokeDasharray={circumference}
//           strokeDashoffset={offset}
//           strokeLinecap="round"
//         />
//       </svg>
//       <div className="hra-wellness-center absolute inset-0 flex flex-col items-center justify-center px-4">
//         <span className="hra-wellness-score text-4xl font-bold text-on-primary-fixed-var leading-none">{safe}</span>
//         <span className="hra-wellness-sub text-[10px] text-on-surface-variant uppercase tracking-widest mt-1">Out of 100</span>
//       </div>
//     </div>
//   );
// };

// const HraResult = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const [downloading, setDownloading] = useState(false);
//   const reportRef = useRef(null);

//   useEffect(() => {
//     if (!state) navigate("/hra-category", { replace: true });
//   }, [state, navigate]);

//   if (!state) return null;

//   const {
//     riskLevel = "Unknown",
//     riskMessage = "No risk assessment available",
//     prescribedForCategories = {},
//     wellnessScore: stateWellnessScore,
//     score = 0,
//     categoryPoints = {},
//     personalInfo = {},
//     completedAt,
//   } = state;

//   const rawWellness = Number.isFinite(Number(stateWellnessScore))
//     ? Number(stateWellnessScore)
//     : Number.isFinite(Number(score))
//       ? Number(score)
//       : null;

//   const categoryValues = Object.values(categoryPoints).map((v) => Number(v) || 0);
//   const categoryAvg =
//     categoryValues.length > 0
//       ? Math.round(categoryValues.reduce((s, v) => s + v, 0) / categoryValues.length)
//       : 0;

//   const wellnessScore =
//     rawWellness != null && rawWellness > 0
//       ? Math.min(100, Math.max(0, Math.round(rawWellness)))
//       : categoryAvg > 0
//         ? categoryAvg
//         : rawWellness != null
//           ? Math.min(100, Math.max(0, Math.round(rawWellness)))
//           : 0;

//   const completedDate = completedAt
//     ? new Date(completedAt).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })
//     : new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

//   const categories = Object.entries(categoryPoints);
//   const recommendations = Object.entries(prescribedForCategories);
//   const isModerate = (riskLevel || "").toLowerCase().includes("moderate");

//   const handleDownloadPdf = async () => {
//     if (!reportRef.current) return;
//     setDownloading(true);
//     try {
//       await downloadHraReportPdf(reportRef.current, { completedAt, completedDate });
//     } catch {
//       toast.error("Could not generate PDF. Please try again.");
//     } finally {
//       setDownloading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-background flex flex-col pb-16 lg:pb-0">
//       <Header />

//       <main className="flex-1 max-w-6xl mx-auto w-full px-3 sm:px-6 py-4 sm:py-8">
//         <div className="flex justify-between items-start">
//           <div className="mb-4 sm:mb-6">
//             <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-on-primary-fixed-var">
//               Comprehensive Health Risk Assessment Results
//             </h1>
//             <p className="text-xs sm:text-sm text-on-surface-variant mt-1">Completed on {completedDate}</p>
//           </div>
//           <button
//             type="button"
//             onClick={handleDownloadPdf}
//             disabled={downloading}
//             className="btn-primary inline-flex items-center justify-center gap-2 w-full sm:w-auto shrink-0 disabled:opacity-60"
//           >
//             <FaDownload size={14} />
//             {downloading ? "Downloading…" : "Download PDF"}
//           </button>
//         </div>

//         <div id="hra-report-print" ref={reportRef}>

//           <div className="flex flex-col md:flex-row gap-4 sm:gap-6 mb-4 sm:mb-6">
//             <div className="card p-4 sm:p-6 lg:p-8 flex-1 min-w-0">
//               <h3 className="font-bold text-on-primary-fixed-var text-center mb-4 sm:mb-6">Overall Wellness Score</h3>
//               <WellnessRing score={wellnessScore} />
//               <div className="text-center mt-6">
//                 <span
//                   data-hra-pill
//                   className={`inline-flex items-center justify-center gap-1 leading-none px-4 py-1.5 rounded-full text-xs font-bold uppercase ${riskBadgeClass(riskLevel)}`}
//                 >
//                   {isModerate && <FaStar size={10} className="shrink-0" />}
//                   {!isModerate && <span className="w-2 h-2 rounded-full bg-current opacity-70 shrink-0" />}
//                   {riskLevel} Risk
//                 </span>
//               </div>
//               <p className="text-sm text-on-surface-variant text-center mt-5 leading-relaxed px-2">
//                 {riskMessage}
//               </p>
//             </div>

//             <div className="card p-4 sm:p-6 flex-1 min-w-0">
//               <div className="flex items-center gap-2 mb-4 sm:mb-5">
//                 <FaChartLine className="text-primary" />
//                 <h3 className="font-bold text-on-primary-fixed-var">Vitals Snapshot</h3>
//               </div>
//               <div className="space-y-4">
//                 <div className="flex justify-between text-sm border-b border-surface-container pb-3">
//                   <span className="text-on-surface-variant">Blood Pressure</span>
//                   <span className="font-semibold text-on-primary-fixed-var">
//                     {personalInfo.bp || personalInfo.bpSys
//                       ? `${personalInfo.bp || `${personalInfo.bpSys}/${personalInfo.bpDia}`} mmHg`
//                       : "—"}
//                   </span>
//                 </div>
//                 <div className="flex justify-between text-sm border-b border-surface-container pb-3">
//                   <span className="text-on-surface-variant">BMI</span>
//                   <span className="font-semibold text-on-primary-fixed-var">
//                     {personalInfo.bmi != null
//                       ? `${personalInfo.bmi.toFixed(1)} ${personalInfo.bmiCategory || ""}`
//                       : "—"}
//                   </span>
//                 </div>
//                 <div className="flex justify-between text-sm">
//                   <span className="text-on-surface-variant">Weight</span>
//                   <span className="font-semibold text-on-primary-fixed-var">
//                     {personalInfo.weightKg != null
//                       ? `${Math.round(personalInfo.weightKg)} Kgs`
//                       : "—"}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
//             <div className="card p-4 sm:p-6">
//                 <h3 className="font-bold text-on-primary-fixed-var mb-1">Category Breakdown</h3>
//                 <p className="text-sm text-on-surface-variant mb-5 leading-relaxed">
//                   Your overall health is solid, but there are a few areas we recommend focusing on to maintain optimal wellbeing.
//                 </p>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
//                   {categories.length > 0 ? (
//                     categories.slice(0, 4).map(([name, points]) => {
//                       const Icon = getCategoryIcon(name);
//                       const pct = Math.min(100, Math.round(Number(points) || 0));
//                       const status = scoreToStatus(pct);
//                       const desc = getCategoryDescription(name, prescribedForCategories[name]);
//                       return (
//                         <div key={name} className="border border-surface-container rounded-xl p-3 sm:p-4 bg-surface-lowest">
//                           <div className="flex items-start gap-2 mb-2">
//                             <Icon className="text-primary shrink-0 mt-0.5" size={14} />
//                             <span className="min-w-0 flex-1 text-sm font-semibold leading-snug text-on-primary-fixed-var break-words">
//                               {name}
//                             </span>
//                           </div>
//                           <span
//                             data-hra-pill
//                             className={`inline-flex items-center justify-center leading-none text-[10px] font-bold px-2 py-0.5 rounded-full mb-2 ${status.color}`}
//                           >
//                             {status.label}
//                           </span>
//                           <div className="h-1.5 bg-surface-container rounded-full overflow-hidden mb-2">
//                             <div
//                               className={`h-full rounded-full ${status.label === "ELEVATED" ? "bg-error" : "bg-primary"}`}
//                               style={{ width: `${pct}%` }}
//                             />
//                           </div>
//                           <p className="text-[11px] text-on-surface-variant leading-relaxed">{desc}</p>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <p className="text-sm text-on-surface-variant col-span-2">Category scores will appear once available from your assessment.</p>
//                   )}
//                 </div>
//             </div>

//             <div className="card p-4 sm:p-6">
//                   <h3 className="font-bold text-on-primary-fixed-var mb-1">Recommended Next Steps</h3>
//                   <p className="text-sm text-on-surface-variant mb-5">
//                     Based on your assessment, our clinical algorithm recommends the following actions.
//                   </p>
//                   <div className="space-y-3">
//                     {recommendations.length > 0 ? (
//                       recommendations.map(([category, text], i) => (
//                         <div
//                           key={category}
//                           className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 bg-surface-low rounded-xl p-3 sm:p-4"
//                         >
//                           {i % 2 === 0 ? (
//                             <FaFlask className="text-primary shrink-0" size={18} />
//                           ) : (
//                             <FaCalendarAlt className="text-primary shrink-0" size={18} />
//                           )}
//                           <div className="flex-1 min-w-0">
//                             <p className="font-semibold text-sm text-on-primary-fixed-var">{category}</p>
//                             <p className="text-xs text-on-surface-variant mt-0.5 leading-relaxed">{text}</p>
//                           </div>
//                           <Link
//                             to={i % 2 === 0 ? "/lab-tests" : "/consultations"}
//                             data-pdf-hide
//                             className={`shrink-0 text-xs px-4 py-2 rounded-full font-semibold text-center w-full sm:w-auto ${i % 2 === 0 ? "btn-primary" : "btn-outline"
//                               }`}
//                           >
//                             {i % 2 === 0 ? "Schedule" : "Book Consult"}
//                           </Link>
//                         </div>
//                       ))
//                     ) : (
//                       <p className="text-sm text-on-surface-variant">{riskMessage}</p>
//                     )}
//                   </div>
//             </div>
//           </div>

//           {categories.length > 0 && (
//             <section className="mb-6 sm:mb-8">
//               <h3 className="font-bold text-on-primary-fixed-var mb-3 sm:mb-4">Detailed Risk Breakdown</h3>
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
//                 {categories.map(([name, points]) => {
//                   const Icon = getCategoryIcon(name);
//                   const pct = Math.min(100, Math.round(Number(points) || 0));
//                   const isLow = pct >= 60;
//                   const desc = getCategoryDescription(name, prescribedForCategories[name]);
//                   return (
//                     <div key={name} className="card p-3 sm:p-4 flex flex-col min-h-[120px] sm:min-h-[140px]">
//                       <div className="flex items-center justify-between mb-3">
//                         <Icon className="text-primary" size={16} />
//                         <span
//                           data-hra-pill
//                           className={`inline-flex items-center justify-center leading-none text-[10px] font-bold px-2 py-0.5 rounded-full ${isLow ? "bg-primary-fixed/30 text-primary" : "bg-error-container text-error"}`}
//                         >
//                           {isLow ? "Low Risk" : "Mod Risk"}
//                         </span>
//                       </div>
//                       <p className="font-semibold text-sm text-on-primary-fixed-var mb-1">{name}</p>
//                       <p className="text-xs text-on-surface-variant flex-1 mb-3 leading-relaxed">{desc}</p>
//                       <div className="h-1 bg-surface-container rounded-full overflow-hidden mt-auto">
//                         <div
//                           className={`h-full rounded-full ${isLow ? "bg-primary" : "bg-error"}`}
//                           style={{ width: `${pct}%` }}
//                         />
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}
//         </div>

//         <div className="text-center pb-4">
//           <button
//             type="button"
//             onClick={() => navigate("/home")}
//             className="btn-primary px-10 py-3"
//           >
//             Back to Dashboard
//           </button>
//         </div>
//       </main>

//       <Footer hipaaNote />
//     </div>
//   );
// };

// export default HraResult;


import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  FaHeart,
  FaTint,
  FaUtensils,
  FaBrain,
  FaFlask,
  FaCalendarAlt,
  FaChartLine,
  FaDownload,
  FaStar,
} from "react-icons/fa";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { downloadHraReportPdf } from "../utils/hraPdf";
import { toast } from "../Components/Toast";

const CATEGORY_ICONS = {
  cardiac: FaHeart,
  cardiovascular: FaHeart,
  metabolic: FaTint,
  lifestyle: FaUtensils,
  mental: FaBrain,
  default: FaHeart,
};

const CATEGORY_DESCRIPTIONS = {
  cardiac: "Your heart health indicators are within a healthy range.",
  cardiovascular: "Your heart health indicators are within a healthy range.",
  metabolic: "Some metabolic markers may benefit from closer monitoring.",
  lifestyle: "Your activity levels are good, but strength training could help.",
  mental: "Stress and sleep patterns show room for improvement.",
  default: "Based on your responses in this category.",
};

const getCategoryIcon = (name) => {
  const key = (name || "").toLowerCase();
  const match = Object.keys(CATEGORY_ICONS).find((k) => key.includes(k));
  return CATEGORY_ICONS[match] || CATEGORY_ICONS.default;
};

const getCategoryDescription = (name, prescribed) => {
  if (prescribed) return prescribed;
  const key = Object.keys(CATEGORY_DESCRIPTIONS).find((k) => (name || "").toLowerCase().includes(k));
  return CATEGORY_DESCRIPTIONS[key] || CATEGORY_DESCRIPTIONS.default;
};

const scoreToStatus = (pct) => {
  const p = Number(pct) || 0;
  if (p >= 80) return { label: "OPTIMAL", color: "bg-primary text-white" };
  if (p >= 60) return { label: "GOOD", color: "bg-primary-fixed/50 text-primary" };
  if (p >= 40) return { label: "FAIR", color: "bg-tertiary-container text-on-tertiary-container" };
  return { label: "ELEVATED", color: "bg-error-container text-error" };
};

const riskBadgeClass = (level) => {
  const l = (level || "").toLowerCase();
  if (l.includes("low")) return "bg-primary-fixed/30 text-primary";
  if (l.includes("moderate") || l.includes("mod")) return "bg-error-container text-error border border-error/20";
  if (l.includes("high")) return "bg-error-container text-error";
  return "bg-surface-low text-on-surface-variant";
};

const WellnessRing = ({ score }) => {
  const safe = Number.isFinite(score) ? Math.min(100, Math.max(0, score)) : 0;
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (safe / 100) * circumference;

  return (
    <div className="relative w-40 h-40 sm:w-48 sm:h-48 mx-auto">
      <svg className="w-full h-full -rotate-90" viewBox="0 0 160 160">
        <circle cx="80" cy="80" r={radius} fill="none" stroke="#e5e7eb" strokeWidth="12" />
        <circle
          cx="80"
          cy="80"
          r={radius}
          fill="none"
          stroke="#006A4E"
          strokeWidth="12"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div className="hra-wellness-center absolute inset-0 flex flex-col items-center justify-center px-4">
        <span className="hra-wellness-score text-4xl font-bold text-on-primary-fixed-var leading-none">{safe}</span>
        <span className="hra-wellness-sub text-[10px] text-on-surface-variant uppercase tracking-widest mt-1">Out of 100</span>
      </div>
    </div>
  );
};

const HraResult = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);
  const reportRef = useRef(null);

  useEffect(() => {
    if (!state) navigate("/hra-category", { replace: true });
  }, [state, navigate]);

  if (!state) return null;

  const {
    riskLevel = "Unknown",
    riskMessage = "No risk assessment available",
    prescribedForCategories = {},
    wellnessScore: stateWellnessScore,
    score = 0,
    categoryPoints = {},
    personalInfo = {},
    completedAt,
  } = state;

  const rawWellness = Number.isFinite(Number(stateWellnessScore))
    ? Number(stateWellnessScore)
    : Number.isFinite(Number(score))
      ? Number(score)
      : null;

  const categoryValues = Object.values(categoryPoints).map((v) => Number(v) || 0);
  const categoryAvg =
    categoryValues.length > 0
      ? Math.round(categoryValues.reduce((s, v) => s + v, 0) / categoryValues.length)
      : 0;

  const wellnessScore =
    rawWellness != null && rawWellness > 0
      ? Math.min(100, Math.max(0, Math.round(rawWellness)))
      : categoryAvg > 0
        ? categoryAvg
        : rawWellness != null
          ? Math.min(100, Math.max(0, Math.round(rawWellness)))
          : 0;

  const completedDate = completedAt
    ? new Date(completedAt).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })
    : new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

  const categories = Object.entries(categoryPoints);
  const recommendations = Object.entries(prescribedForCategories);
  const isModerate = (riskLevel || "").toLowerCase().includes("moderate");

  const handleDownloadPdf = async () => {
    if (!reportRef.current) return;
    setDownloading(true);
    try {
      await downloadHraReportPdf(reportRef.current, { completedAt, completedDate });
    } catch {
      toast.error("Could not generate PDF. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col pb-16 lg:pb-0">
      <Header />

      <main className="flex-1 max-w-6xl mx-auto w-full px-3 sm:px-6 py-4 sm:py-8">
        <div className="flex justify-between items-start">
          <div className="mb-4 sm:mb-6">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-on-primary-fixed-var">
              Comprehensive Health Risk Assessment Results
            </h1>
            <p className="text-xs sm:text-sm text-on-surface-variant mt-1">Completed on {completedDate}</p>
          </div>
          <button
            type="button"
            onClick={handleDownloadPdf}
            disabled={downloading}
            className="btn-primary inline-flex items-center justify-center gap-2 w-full sm:w-auto shrink-0 disabled:opacity-60"
          >
            <FaDownload size={14} />
            {downloading ? "Downloading…" : "Download PDF"}
          </button>
        </div>

        <div id="hra-report-print" ref={reportRef}>

          <div className="flex flex-col md:flex-row gap-4 sm:gap-6 mb-4 sm:mb-6">
            <div className="card p-4 sm:p-6 lg:p-8 flex-1 min-w-0">
              <h3 className="font-bold text-on-primary-fixed-var text-center mb-4 sm:mb-6">Overall Wellness Score</h3>
              <WellnessRing score={wellnessScore} />
              <div className="text-center mt-6">
                <span
                  data-hra-pill
                  className={`inline-flex items-center justify-center gap-1 leading-none px-4 py-1.5 rounded-full text-xs font-bold uppercase ${riskBadgeClass(riskLevel)}`}
                >
                  {isModerate && <FaStar size={10} className="shrink-0" />}
                  {!isModerate && <span className="w-2 h-2 rounded-full bg-current opacity-70 shrink-0" />}
                  {riskLevel} Risk
                </span>
              </div>
              <p className="text-sm text-on-surface-variant text-center mt-5 leading-relaxed px-2">
                {riskMessage}
              </p>
            </div>

            <div className="card p-4 sm:p-6 flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-4 sm:mb-5">
                <FaChartLine className="text-primary" />
                <h3 className="font-bold text-on-primary-fixed-var">Vitals Snapshot</h3>
              </div>
              <div className="space-y-4">
                <div className="flex justify-between text-sm border-b border-surface-container pb-3">
                  <span className="text-on-surface-variant">Blood Pressure</span>
                  <span className="font-semibold text-on-primary-fixed-var">
                    {personalInfo.bp?.systolic}/{personalInfo.bp?.diastolic} mmHg
                  </span>
                </div>
                <div className="flex justify-between text-sm border-b border-surface-container pb-3">
                  <span className="text-on-surface-variant">BMI</span>
                  <span className="font-semibold text-on-primary-fixed-var">
                    {personalInfo.bmi != null
                      ? `${personalInfo.bmi.toFixed(1)} ${personalInfo.bmiCategory || ""}`
                      : "—"}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-on-surface-variant">Weight</span>
                  <span className="font-semibold text-on-primary-fixed-var">
                    {personalInfo.weightKg} Kgs
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
            <div className="card p-4 sm:p-6">
              <h3 className="font-bold text-on-primary-fixed-var mb-1">Category Breakdown</h3>
              <p className="text-sm text-on-surface-variant mb-5 leading-relaxed">
                Your overall health is solid, but there are a few areas we recommend focusing on to maintain optimal wellbeing.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                {categories.length > 0 ? (
                  categories.slice(0, 4).map(([name, points]) => {
                    const Icon = getCategoryIcon(name);
                    const pct = Math.min(100, Math.round(Number(points) || 0));
                    const status = scoreToStatus(pct);
                    const desc = getCategoryDescription(name, prescribedForCategories[name]);
                    return (
                      <div key={name} className="border border-surface-container rounded-xl p-3 sm:p-4 bg-surface-lowest">
                        <div className="flex items-start gap-2 mb-2">
                          <Icon className="text-primary shrink-0 mt-0.5" size={14} />
                          <span className="min-w-0 flex-1 text-sm font-semibold leading-snug text-on-primary-fixed-var break-words">
                            {name}
                          </span>
                        </div>
                        <span
                          data-hra-pill
                          className={`inline-flex items-center justify-center leading-none text-[10px] font-bold px-2 py-0.5 rounded-full mb-2 ${status.color}`}
                        >
                          {status.label}
                        </span>
                        <div className="h-1.5 bg-surface-container rounded-full overflow-hidden mb-2">
                          <div
                            className={`h-full rounded-full ${status.label === "ELEVATED" ? "bg-error" : "bg-primary"}`}
                            style={{ width: `${pct}%` }}
                          />
                        </div>
                        <p className="text-[11px] text-on-surface-variant leading-relaxed">{desc}</p>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-sm text-on-surface-variant col-span-2">Category scores will appear once available from your assessment.</p>
                )}
              </div>
            </div>

            <div className="card p-4 sm:p-6">
              <h3 className="font-bold text-on-primary-fixed-var mb-1">Recommended Next Steps</h3>
              <p className="text-sm text-on-surface-variant mb-5">
                Based on your assessment, our clinical algorithm recommends the following actions.
              </p>
              <div className="space-y-3">
                {recommendations.length > 0 ? (
                  recommendations.map(([category, text], i) => (
                    <div
                      key={category}
                      className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 bg-surface-low rounded-xl p-3 sm:p-4"
                    >
                      {i % 2 === 0 ? (
                        <FaFlask className="text-primary shrink-0" size={18} />
                      ) : (
                        <FaCalendarAlt className="text-primary shrink-0" size={18} />
                      )}
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-sm text-on-primary-fixed-var">{category}</p>
                        <p className="text-xs text-on-surface-variant mt-0.5 leading-relaxed">{text}</p>
                      </div>
                      <Link
                        to={i % 2 === 0 ? "/lab-tests" : "/consultations"}
                        data-pdf-hide
                        className={`shrink-0 text-xs px-4 py-2 rounded-full font-semibold text-center w-full sm:w-auto ${i % 2 === 0 ? "btn-primary" : "btn-outline"
                          }`}
                      >
                        {i % 2 === 0 ? "Schedule" : "Book Consult"}
                      </Link>
                    </div>
                  ))
                ) : (
                  <p className="text-sm text-on-surface-variant">{riskMessage}</p>
                )}
              </div>
            </div>
          </div>

          {categories.length > 0 && (
            <section className="mb-6 sm:mb-8">
              <h3 className="font-bold text-on-primary-fixed-var mb-3 sm:mb-4">Detailed Risk Breakdown</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
                {categories.map(([name, points]) => {
                  const Icon = getCategoryIcon(name);
                  const pct = Math.min(100, Math.round(Number(points) || 0));
                  const isLow = pct >= 60;
                  const desc = getCategoryDescription(name, prescribedForCategories[name]);
                  return (
                    <div key={name} className="card p-3 sm:p-4 flex flex-col min-h-[120px] sm:min-h-[140px]">
                      <div className="flex items-center justify-between mb-3">
                        <Icon className="text-primary" size={16} />
                        <span
                          data-hra-pill
                          className={`inline-flex items-center justify-center leading-none text-[10px] font-bold px-2 py-0.5 rounded-full ${isLow ? "bg-primary-fixed/30 text-primary" : "bg-error-container text-error"}`}
                        >
                          {isLow ? "Low Risk" : "Mod Risk"}
                        </span>
                      </div>
                      <p className="font-semibold text-sm text-on-primary-fixed-var mb-1">{name}</p>
                      <p className="text-xs text-on-surface-variant flex-1 mb-3 leading-relaxed">{desc}</p>
                      <div className="h-1 bg-surface-container rounded-full overflow-hidden mt-auto">
                        <div
                          className={`h-full rounded-full ${isLow ? "bg-primary" : "bg-error"}`}
                          style={{ width: `${pct}%` }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          )}
        </div>

        <div className="text-center pb-4">
          <button
            type="button"
            onClick={() => navigate("/home")}
            className="btn-primary px-10 py-3"
          >
            Back to Dashboard
          </button>
        </div>
      </main>

      <Footer hipaaNote />
    </div>
  );
};

export default HraResult;
